import { useEffect, useRef } from "react";

const useStickyHeader = (tableRef: React.RefObject<HTMLTableElement>, pageContainerRef: React.RefObject<HTMLElement>) => {
  useEffect(() => {
    const handleScroll = () => {
      const table = tableRef.current;
      if (!table) return; 
      const thead = table.querySelector("thead") as HTMLTableSectionElement;
      if (!thead) return; 

      const scrollTop = window.scrollY;
      const tableOffset = table.getBoundingClientRect().top + scrollTop;
      const tableHeight = table.offsetHeight;

      const distance = tableOffset - scrollTop;

      if (distance < 0 && distance + tableHeight > 0) {
        thead.style.position = "sticky";
        thead.style.top = `${-distance}px`;
      } else {
        thead.style.position = "sticky";
        thead.style.top = "0px";
      }
    };

    const pageContainer = pageContainerRef.current;
    if (!pageContainer) return; 

    pageContainer.addEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll);

    return () => {
      pageContainer.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [tableRef, pageContainerRef]);
};

export default useStickyHeader;
